import { render, staticRenderFns } from "./sign-in.vue?vue&type=template&id=e670ef88&scoped=true&"
import script from "./sign-in.vue?vue&type=script&lang=ts&"
export * from "./sign-in.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e670ef88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\VelipetteriLehto\\Projects\\Europress\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e670ef88')) {
      api.createRecord('e670ef88', component.options)
    } else {
      api.reload('e670ef88', component.options)
    }
    module.hot.accept("./sign-in.vue?vue&type=template&id=e670ef88&scoped=true&", function () {
      api.rerender('e670ef88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/view/authentication/sign-in.vue"
export default component.exports